import {
  KEABPMNSwimlane,
  KEAElement,
  KEAGraph,
  KEALink,
  KEAPolygon,
  KEARectangle,
  KEAUMLActivityNode,
  KEAUMLArea,
  KEAUMLCircleState,
  KEAUMLReceiveSymbol,
  KEAUMLSendSymbol,
  LabelPosition,
  LinkConfiguration,
  LinkLabelPosition,
  LinkType,
  MarkerPosition,
  MarkerType,
  StateType,
  keaNamespace,
} from "@kea-mod/jointjs";

import { KEAUMLForkAndJoin } from "@kea-mod/jointjs/components/KEAUMLForkAndJoin";
import { TemplateConfiguration } from "./TemplateConfiguration";
import { KEAUMLPort } from "../uml_component/KEAUMLPort";

const activityNode = new KEAUMLActivityNode();
activityNode.position(10, 10);

const umlForkAndJoin = new KEAUMLForkAndJoin();
umlForkAndJoin.position(310, 120);

const send = new KEAUMLSendSymbol();
send.position(10, 120);

const receive = new KEAUMLReceiveSymbol();
receive.position(140, 120);

const area = new KEAUMLArea();
area.size(280, 100);
area.position(10, 190);

const umlChoice = new KEAPolygon();
umlChoice.position(10, 310);
umlChoice.setLabelPosition(LabelPosition.BELOW);
umlChoice.size(30, 30);

const initialUMLCircleActivity = new KEAUMLCircleState();
initialUMLCircleActivity.position(60, 310);
initialUMLCircleActivity.setStateType(StateType.INITIAL);

const exitUMLCircleActivity = new KEAUMLCircleState();
exitUMLCircleActivity.position(110, 310);
exitUMLCircleActivity.setStateType(StateType.EXIT);

const finalUMLCircleActivity = new KEAUMLCircleState();
finalUMLCircleActivity.position(160, 310);
finalUMLCircleActivity.setStateType(StateType.FINAL);

const swimlane = new KEABPMNSwimlane().position(10, 350).setNumberOfLanes(1);

const pin = new KEAUMLPort();
pin.position(340, 120);

const object = new KEARectangle();
object.setResizeHeight(true);
object.setResizeWidth(true);
object.position(230, 10);

const link = new KEALink();
link.source({ x: 10, y: 550 });
link.target({ x: 290, y: 550 });
link.setKEALabel({ position: LinkLabelPosition.MID, value: "" });
link.setDasharray(LinkType.SOLID);
link.setMarker(MarkerPosition.SOURCE_MARKER, MarkerType.NONE);
link.setMarker(MarkerPosition.TARGET_MARKER, MarkerType.ARROW);

let defaultLink = link.clone();

export const getUMLActivityConfiguration = (): Array<KEAElement | KEALink> => {
  return [
    initialUMLCircleActivity,
    exitUMLCircleActivity,
    finalUMLCircleActivity,
    umlChoice,
    umlForkAndJoin,
    send,
    receive,
    activityNode,
    area,
    link,
    swimlane,
    pin,
    object,
  ];
};

export const getUMLActivityMarkup = (): TemplateConfiguration => {
  const conf: LinkConfiguration = {
    editPathTypeEnabled: true,
    editSourceMarkerEnabled: false,
    editTargetMarkerEnabled: false,
    sourceLabelEnabled: false,
    midLabelEnabled: true,
    targetLabelEnabled: false,
  };
  const graph = new KEAGraph({}, { cellNamespace: keaNamespace });
  graph.addCells(getUMLActivityConfiguration());
  return new TemplateConfiguration(
    graph.toJSON(),
    1,
    () => {
      return defaultLink;
    },
    conf,
  );
};
